// extracted by mini-css-extract-plugin
export var banner = "_s3-0";
export var settingRow = "_s3-2";
export var titleIcon = "_s3-1";